import React from 'react';
import PatientDemographicsHeader from './PatientDemographicsHeader';

import styles from './HDFormatWrapper.module.css';

/**
 * HDFormatWrapper - Universal wrapper that formats any AI report into HD report structure
 *
 * Structure:
 * 1. Patient Demographics Header (top) - only for single patient reports
 * 2. Report Content (middle) - passed as children
 * 3. User Details Footer (bottom) - staff signature section
 *
 * @param {Object} reportData - The complete report data from backend
 * @param {Object} reportData.patient_demographics - Patient info (mrn, name, gender, age, dob)
 * @param {boolean} reportData.is_multi_patient - Flag for multi-patient reports
 * @param {number} reportData.patient_count - Number of patients in report
 * @param {Object} reportData.metadata - User/staff information
 * @param {ReactNode} children - The report content to be wrapped
 */
const HDFormatWrapper = ({ reportData, children }) => {
  if (!reportData) {
    return children; // Fallback: no wrapper if no data
  }

  const {
    patient_demographics,
    is_multi_patient = false,
    patient_count = 0,
    metadata,
  } = reportData;

  return (
    <div className={styles.hdFormatReport}>
      {/* Patient Demographics Header - Only for single patient reports */}
      {patient_demographics && !is_multi_patient && (
        <PatientDemographicsHeader patient={patient_demographics} />
      )}

      {/* Multi-Patient Banner - Show when report includes multiple patients */}
      {is_multi_patient && patient_count > 0 && (
        <div className={styles.multiPatientBanner}>
          <span className={styles.bannerIcon}>📊</span>
          <span className={styles.bannerText}>
            Report includes {patient_count} patient{patient_count !== 1 ? 's' : ''}
          </span>
        </div>
      )}

      {/* Main Report Content - Passed as children, completely unchanged */}
      <div className={styles.reportContent}>{children}</div>


    </div>
  );
};

export default HDFormatWrapper;
